import {Fragment, h} from 'preact';
import s from "./searchBar.module.css";
import {iconSearchBlack} from "../../../../assets/";
import {useSearchBar} from './useSearchBar';
import {useAppContext} from '../../../../contexts';

const SearchBar = () => {
    // Component logic data
    const componentProps = useSearchBar();

    // Destructured component logic data
    const {
        searchBarData,
        handleSearchBar,
        handleSubmit,
        handleFilter,
        inputRef
    } = componentProps;

    // Accessibility feature data
    const {
        accessibilityFont,
        highContrast
    } = useAppContext();

    return (
        <Fragment>
            <div className={`w-full max-w-full md:max-w-[442px] flex flex-col flex-1`}>
                <form
                    onSubmit={handleSubmit}
                    className={"h-full flex items-center lg:flex-col lg:justify-center w-full"}
                    data-testid="searchbar-form"
                >
                    <div className={`w-full ${s.searchContainer}`}>
                        <div className={`relative h-full`}>
                            <input
                                ref={inputRef}
                                value={searchBarData["query"]}
                                type="text"
                                className={`font-museo ${s.searchInput}`}
                                placeholder="O que você procura?"
                                id={"searchbar-input"}
                                data-testid="searchbar-input"
                                onClick={() => handleSearchBar("isOpen", true)}
                                onInput={e => handleFilter(e)}
                            />
                            <button
                                type="submit"
                                className={`${s.searchButton} ${highContrast ? "" : s.searchFilter} dark:bg-contrast-yellow`}
                                style={{
                                    fontSize: `${14 + accessibilityFont}px`
                                }}
                                data-testid="searchbar-button"
                            >
                                <img
                                    src={iconSearchBlack}
                                    alt={"Search icon"}
                                    data-testid="searchbar-icon"
                                />
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </Fragment>
    )
}

export default SearchBar;
